import React, { useState, useEffect } from "react";
import styles from "../styles/pricing.module.css";
import { useNavigate } from "react-router-dom";
import pricingPlans from "../data/pricingPlans";

const Pricing = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState(null);

  useEffect(() => {
    try {
      const userDataRaw = localStorage.getItem("userData");
      if (userDataRaw) {
        const userData = JSON.parse(userDataRaw);
        setUserEmail(userData?.email || null);
      }
    } catch (error) {
      console.error("Error reading user data from localStorage:", error);
      setUserEmail(null);
    }
  }, []);

  const handlePayment = (plan) => {
    if (plan.price === 0) {
      if (userEmail) {
        console.log("Free plan selected, navigating to dashboard...");
        navigate("/dashboard");
      } else {
        console.log("Free plan selected, user not logged in → login page");
        navigate("/login", { state: { fromFreePlan: true } });
      }
      return;
    }
    const paymentState = {
      selectedPlanName: plan.name,
      amount: plan.price,
      credits: plan.credits,
    };

    if (userEmail) {
      console.log("Navigating to checkout for plan:", plan.name);
      navigate("/buy", { state: paymentState });
    } else {
      console.log(
        "User not logged in, navigating to login for plan:",
        plan.name
      );
      navigate("/login", {
        state: { fromPricing: true, planToBuy: plan.name, paymentState },
      });
    }
  };

  const renderFeature = (featureText) => {
    const parts = featureText.split("**");
    return parts.map((part, index) =>
      index % 2 === 1 ? <strong key={index}>{part}</strong> : part
    );
  };

  return (
    <section id="pricing" className={styles.pricingSection}>
      <div className={styles.contentWrapper}></div>
      <h2 className={styles.sectionTitle}>
        Choose Your Application Credit Pack
      </h2>
      <div className={styles.pricingCardsGrid}>
        {pricingPlans.map((plan, index) => (
          <div
            key={index}
            className={`${styles.pricingCard} ${
              plan.popular ? styles.popular : ""
            }`}
          >
            {plan.popular && (
              <div className={styles.popularBadge}>Most Popular</div>
            )}

            <div className={styles.planName}>{plan.name}</div>

            <div className={styles.priceSection}>
              <div className={styles.totalPrice}>
                ₹{plan.price}
                <span className={styles.totalApps}>
                  Total for {plan.credits} Credits
                </span>
              </div>
            </div>

            <ul className={styles.featuresList}>
              {plan.features.map((feature, i) => (
                <li key={i}>
                  <i className="fas fa-check-circle" aria-hidden="true"></i>{" "}
                  {renderFeature(feature)}{" "}
                </li>
              ))}
            </ul>

            {/* <button
              className={styles.choosePlanButton}
              onClick={() => handlePayment(plan)}
              title={`Select the ${plan.name} plan`}
            >
              Choose {plan.name}
            </button> */}
            <button
              className={styles.choosePlanButton}
              onClick={() => handlePayment(plan)}
              title={`Select the ${plan.name} plan`}
            >
              Get Started
            </button>
          </div>
        ))}
      </div>

      <p className={styles.pricingFooter}>
        These plans focus on <strong>LinkedIn Easy Apply</strong> automation
        credits.
      </p>
      <div />
    </section>
  );
};

export default Pricing;
